import { useMySelector } from 'featureSliced/shared/hooks/useMySelector'
import { ICategory } from 'featureSliced/shared/store/reducers/CategoriesReducer/types'

export const useGetTranslatedNames = () => {
  const { selectedLanguage } = useMySelector((state) => state.common)
  const translations = useMySelector((state) => state.translations.items)

  const getCategoryName = (category: Pick<ICategory, 'id' | 'name'>) => {
    const res = translations?.[selectedLanguage]?.categoryTitles?.[category?.id]
    if (typeof res === 'string') return res
    return category?.name || ''
  }

  const getProductName = (product: any) => {
    const res = translations?.[selectedLanguage]?.productTitles?.[product?.id]
    if (typeof res === 'string') return res
    return product?.title || ''
  }

  return { getCategoryName, getProductName }
}
